// Example Usage:
// (
//  'mox',
//  [{ forename: 'David', surname: 'Moxon' }, { forename: 'Liam', surname: 'Mclaughlin'}],
//  { forename: searchCi, surname: searchCi }
// )
import {isEmpty} from 'lodash'

const filterByProps = (value, array, spec) => {
  // No filtering
  if (value === null || value.length === 0) return array

  // Expand out the search spec
  const props = { ...spec }
  for (const i in props) {
    props[i] = props[i](value)
  }

  // Build the test function
  const test = (item) => {
    for (const i in props) {
      if (props[i](item[i])) return true
    }
    return false
  }

  // Filter the results according to the spec
  return array.filter((item) => test(item))
}

// Simple case-sensitive test
const searchCs = (search) => {
  return (v) => (v != null && v.indexOf(search) >= 0)
}

// Simple case-insensitive test
const searchCi = (search) => {
  search = search.toString().toLowerCase()
  return (v) => (v != null && v.toLowerCase().indexOf(search) >= 0)
}

// Sort the contacts in order to display first the recently opened and then the pinned contacts
const sortRecentPinned = (recentPinnedContacts) => {
  return recentPinnedContacts.sort((a, b) => {
    return a.pinned - b.pinned
  })
}

export const getFilterBarFilters = (key, options) => {
  const filters = {
    [key]: options.map(option => option.value),
  }

  if (key === 'userTypes' && isEmpty(options)) {
    filters['contacts'] = []
  }

  if (key === 'selectedRoles' && isEmpty(options)) {
    filters['selectedContacts'] = []
  }

  if (key === 'dateTypes' && isEmpty(options)) {
    filters['targetStart'] = null
    filters['targetEnd'] = null
    filters['timeKey'] = null
  }

  return filters
}

export default {
  filterByProps,
  searchCs,
  searchCi,
  sortRecentPinned,
}
